import { MIN_AXIS_TRUNCATION_SIZE } from '../../core/components/axes/constants.js';

export const gridTemplateColumns = (
  leftAxisMaxWidth: number | 'auto' = 'auto',
  rightAxisMaxWidth: number | 'auto' = 'auto',
) => {
  const leftMax =
    typeof leftAxisMaxWidth === 'number'
      ? `${Math.max(leftAxisMaxWidth, MIN_AXIS_TRUNCATION_SIZE)}px`
      : leftAxisMaxWidth;

  const rightMax =
    typeof rightAxisMaxWidth === 'number'
      ? `${Math.max(rightAxisMaxWidth, MIN_AXIS_TRUNCATION_SIZE)}px`
      : rightAxisMaxWidth;

  return `minmax(0, ${leftMax}) auto minmax(60%, 1fr) auto minmax(0, ${rightMax})`;
};

export const gridTemplateRows = (
  bottomAxisMaxHeight: number | 'auto' = 'auto',
  topAxisMaxHeight: number | 'auto' = 'auto',
  annotationsArea: number | 'auto' = 'auto',
) => {
  const maxTop =
    typeof topAxisMaxHeight === 'number'
      ? `${Math.max(topAxisMaxHeight, MIN_AXIS_TRUNCATION_SIZE)}px`
      : topAxisMaxHeight;

  const maxBottom =
    typeof bottomAxisMaxHeight === 'number'
      ? `${Math.max(bottomAxisMaxHeight, MIN_AXIS_TRUNCATION_SIZE)}px`
      : bottomAxisMaxHeight;

  const annotationsAreaSize =
    typeof annotationsArea === 'number' ? `${annotationsArea}px` : 'auto';

  return `minmax(0, ${annotationsAreaSize}) minmax(0, ${maxTop}) minmax(60%, 1fr) minmax(0, ${maxBottom})`;
};

export const AREAS = {
  annotations: 'annotations',
  topAxis: 'top-axis',
  bottomAxis: 'bottom-axis',
  leftAxis: 'left-axis',
  rightAxis: 'right-axis',
  leftThreshold: 'left-threshold',
  rightThreshold: 'right-threshold',
};

export const gridTemplateAreas = `
  "${AREAS.annotations} ${AREAS.annotations} ${AREAS.annotations} . ."
  ". . ${AREAS.topAxis} . ."
  "${AREAS.leftAxis} ${AREAS.leftThreshold} plot ${AREAS.rightThreshold} ${AREAS.rightAxis}"
  ". . ${AREAS.bottomAxis} . ."
`;
